module.exports = __webpack_public_path__ + "img/rcnn-1.26faa1bb.png";